export default {"src":"/_next/static/media/external-link-blue.c195fcac.svg","height":15,"width":15};